export default __webpack_public_path__ + "static/media/present-pal-logo.621755cb.svg";